// extracted by mini-css-extract-plugin
export default {"time":"styles_time__pLxs+"};